"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteCustomScript = exports.updateCustomScript = exports.createCustomScript = exports.getCustomScripts = exports.deleteCustomJSFailed = exports.deleteCustomJSSuccess = exports.updateCustomJSFailed = exports.updateCustomJSSuccess = exports.createCustomJSFailed = exports.createCustomJS = exports.receivedCustomJS = exports.requestedCustomJS = exports.CustomJSActionTypes = exports.DELETE_CUSTOM_JS_FAILED = exports.DELETE_CUSTOM_JS_SUCCESS = exports.UPDATE_CUSTOM_JS_FAILED = exports.UPDATE_CUSTOM_JS_SUCCESS = exports.CREATE_CUSTOM_JS_FAILED = exports.CREATE_CUSTOM_JS_SUCCESS = exports.RECEIVED_CUSTOM_JS = exports.REQUESTED_CUSTOM_JS = void 0;

var _identity = _interopRequireDefault(require("hs-lodash/identity"));

var _I18n = _interopRequireDefault(require("I18n"));

var _fluxActions = require("flux-actions");

var _CustomJSApi = require("../api/CustomJSApi");

var REQUESTED_CUSTOM_JS = 'REQUESTED_CUSTOM_JS';
exports.REQUESTED_CUSTOM_JS = REQUESTED_CUSTOM_JS;
var RECEIVED_CUSTOM_JS = 'RECEIVED_CUSTOM_JS';
exports.RECEIVED_CUSTOM_JS = RECEIVED_CUSTOM_JS;
var CREATE_CUSTOM_JS_SUCCESS = 'CREATE_CUSTOM_JS_SUCCESS';
exports.CREATE_CUSTOM_JS_SUCCESS = CREATE_CUSTOM_JS_SUCCESS;
var CREATE_CUSTOM_JS_FAILED = 'CREATE_CUSTOM_JS_FAILED';
exports.CREATE_CUSTOM_JS_FAILED = CREATE_CUSTOM_JS_FAILED;
var UPDATE_CUSTOM_JS_SUCCESS = 'UPDATE_CUSTOM_JS_SUCCESS';
exports.UPDATE_CUSTOM_JS_SUCCESS = UPDATE_CUSTOM_JS_SUCCESS;
var UPDATE_CUSTOM_JS_FAILED = 'UPDATE_CUSTOM_JS_FAILED';
exports.UPDATE_CUSTOM_JS_FAILED = UPDATE_CUSTOM_JS_FAILED;
var DELETE_CUSTOM_JS_SUCCESS = 'DELETE_CUSTOM_JS_SUCCESS';
exports.DELETE_CUSTOM_JS_SUCCESS = DELETE_CUSTOM_JS_SUCCESS;
var DELETE_CUSTOM_JS_FAILED = 'DELETE_CUSTOM_JS_FAILED';
exports.DELETE_CUSTOM_JS_FAILED = DELETE_CUSTOM_JS_FAILED;
var CustomJSActionTypes = {
  REQUESTED_CUSTOM_JS: REQUESTED_CUSTOM_JS,
  RECEIVED_CUSTOM_JS: RECEIVED_CUSTOM_JS,
  CREATE_CUSTOM_JS_SUCCESS: CREATE_CUSTOM_JS_SUCCESS,
  CREATE_CUSTOM_JS_FAILED: CREATE_CUSTOM_JS_FAILED,
  UPDATE_CUSTOM_JS_SUCCESS: UPDATE_CUSTOM_JS_SUCCESS,
  UPDATE_CUSTOM_JS_FAILED: UPDATE_CUSTOM_JS_FAILED,
  DELETE_CUSTOM_JS_SUCCESS: DELETE_CUSTOM_JS_SUCCESS,
  DELETE_CUSTOM_JS_FAILED: DELETE_CUSTOM_JS_FAILED
};
exports.CustomJSActionTypes = CustomJSActionTypes;
var requestedCustomJS = (0, _fluxActions.createAction)(REQUESTED_CUSTOM_JS);
exports.requestedCustomJS = requestedCustomJS;
var receivedCustomJS = (0, _fluxActions.createAction)(RECEIVED_CUSTOM_JS, _identity.default);
exports.receivedCustomJS = receivedCustomJS;
var createCustomJS = (0, _fluxActions.createAction)(CREATE_CUSTOM_JS_SUCCESS, _identity.default, function () {
  return {
    notification: {
      message: _I18n.default.text('analyticsAndTracking.customJavascript.createSuccessAlert.message'),
      titleText: _I18n.default.text('analyticsAndTracking.customJavascript.createSuccessAlert.title'),
      type: 'success'
    }
  };
});
exports.createCustomJS = createCustomJS;
var createCustomJSFailed = (0, _fluxActions.createAction)(CREATE_CUSTOM_JS_FAILED, _identity.default, function () {
  return {
    notification: {
      message: _I18n.default.text('analyticsAndTracking.customJavascript.createFailedAlert.message'),
      titleText: _I18n.default.text('analyticsAndTracking.customJavascript.createFailedAlert.title'),
      type: 'danger'
    }
  };
});
exports.createCustomJSFailed = createCustomJSFailed;
var updateCustomJSSuccess = (0, _fluxActions.createAction)(UPDATE_CUSTOM_JS_SUCCESS, _identity.default, function () {
  return {
    notification: {
      message: _I18n.default.text('analyticsAndTracking.customJavascript.editSuccessAlert.message'),
      titleText: _I18n.default.text('analyticsAndTracking.customJavascript.editSuccessAlert.title'),
      type: 'success'
    }
  };
});
exports.updateCustomJSSuccess = updateCustomJSSuccess;
var updateCustomJSFailed = (0, _fluxActions.createAction)(UPDATE_CUSTOM_JS_FAILED, _identity.default, function () {
  return {
    notification: {
      message: _I18n.default.text('analyticsAndTracking.customJavascript.editFailedAlert.message'),
      titleText: _I18n.default.text('analyticsAndTracking.customJavascript.editFailedAlert.title'),
      type: 'danger'
    }
  };
});
exports.updateCustomJSFailed = updateCustomJSFailed;
var deleteCustomJSSuccess = (0, _fluxActions.createAction)(DELETE_CUSTOM_JS_SUCCESS, _identity.default, function () {
  return {
    notification: {
      message: _I18n.default.text('analyticsAndTracking.customJavascript.deleteSuccessAlert.message'),
      titleText: _I18n.default.text('analyticsAndTracking.customJavascript.deleteSuccessAlert.title'),
      type: 'success'
    }
  };
});
exports.deleteCustomJSSuccess = deleteCustomJSSuccess;
var deleteCustomJSFailed = (0, _fluxActions.createAction)(DELETE_CUSTOM_JS_FAILED, _identity.default, function () {
  return {
    notification: {
      message: _I18n.default.text('analyticsAndTracking.customJavascript.deleteFailedAlert.message'),
      titleText: _I18n.default.text('analyticsAndTracking.customJavascript.deleteFailedAlert.title'),
      type: 'danger'
    }
  };
});
exports.deleteCustomJSFailed = deleteCustomJSFailed;

var getCustomScripts = function getCustomScripts() {
  return function (dispatch) {
    dispatch(requestedCustomJS());
    return (0, _CustomJSApi.getCustomJS)().then(function (scripts) {
      dispatch(receivedCustomJS({
        scripts: scripts
      }));
    });
  };
};

exports.getCustomScripts = getCustomScripts;

var createCustomScript = function createCustomScript(name, jsData) {
  return function (dispatch) {
    return (0, _CustomJSApi.addCustomJS)(name, jsData).then(function () {
      dispatch(createCustomJS());
    }).catch(function () {
      dispatch(createCustomJSFailed());
    });
  };
};

exports.createCustomScript = createCustomScript;

var updateCustomScript = function updateCustomScript(id, name, jsData) {
  return function (dispatch) {
    return (0, _CustomJSApi.updateCustomJS)(id, name, jsData).then(function () {
      dispatch(updateCustomJSSuccess());
    }).catch(function (err) {
      dispatch(updateCustomJSFailed(err));
    });
  };
};

exports.updateCustomScript = updateCustomScript;

var deleteCustomScript = function deleteCustomScript(id) {
  return function (dispatch) {
    return (0, _CustomJSApi.deleteCustomJS)(id).then(function () {
      dispatch(deleteCustomJSSuccess());
    }).catch(function () {
      dispatch(deleteCustomJSFailed());
    });
  };
};

exports.deleteCustomScript = deleteCustomScript;